<template>
  <div class="ali-job-delivery-container" :class="{'dark-theme-ali-job-delivery-container': isDarkTheme}">
    <div class="delivery-header" v-if="eligibleCvs.length">
      <div class="title">选择简历</div>
      <div class="desc">仅支持投递 80 分以上的简历</div>
    </div>
    <div class="delivery-header" v-else>
      <div class="title">填写基本信息</div>
    </div>

    <!-- <div>{{ cvs }}</div> -->
    <div class="form-container resume-select" v-if="eligibleCvs.length">
      <el-select v-model="resumeToken" placeholder="请选择" :popper-class="isDarkTheme ? 'dark-theme-ali-job-delivery-select' : ''">
        <el-option
          v-for="item in formatCvs"
          :key="item.token"
          :value="item.token"
          :label="item.cv_name"
          :disabled="item.score < 80"
        >
          <div class="ali-job-delivery-select-resume-option" :class="{disabled: item.score < 80}">
            <div class="name">{{ item.cv_name }}</div>
            <div class="score">{{ item.score }}</div>
            <div class="lang">{{ item.lang==='cn' ? '中文' : '英文' }}</div>
          </div>
        </el-option>
      </el-select>
    </div>
    <div class="form-container resume-form" v-else>
      <el-form ref="jobDeliveryForm" :model="jobDeliveryFormData" :rules="rules">
        <div class="form-item" >
          <div class="edit-module-item-name">学校</div>
          <el-form-item prop="university">
            <el-input placeholder="请输入学校" class="slect-input-auto-main" v-model="jobDeliveryFormData.university" maxlength="50"
            />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">学历</div>
          <el-form-item prop="degree">
            <el-select v-model="jobDeliveryFormData.degree" placeholder="请选择学历" class="slect-input-auto-main">
              <el-option
                v-for="item in degreesOptions"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item" >
          <div class="edit-module-item-name">学院</div>
          <el-form-item prop="dept">
            <el-input placeholder="请输入学院" class="slect-input-auto-main" v-model="jobDeliveryFormData.dept" maxlength="50" />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">毕业时间</div>
          <el-form-item prop="graduated_at">
            <el-date-picker
              v-model="jobDeliveryFormData.graduated_at"
              type="month"
              placeholder="请选择毕业时间"
              class="slect-input-auto-main"
            />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">专业</div>
          <el-form-item prop="major">
            <el-input placeholder="请输入专业" class="slect-input-auto-main" v-model="jobDeliveryFormData.major" maxlength="50" />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">姓名</div>
          <el-form-item prop="name">
            <el-input placeholder="请输入姓名" class="slect-input-auto-main" v-model="jobDeliveryFormData.name" maxlength="50" />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">手机号</div>
          <el-form-item prop="phone">
            <el-input placeholder="请输入手机号" class="slect-input-auto-main" v-model="jobDeliveryFormData.phone" maxlength="50" />
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="edit-module-item-name">邮箱</div>
          <el-form-item prop="email">
            <el-input placeholder="请输入邮箱" class="slect-input-auto-main" v-model="jobDeliveryFormData.email" maxlength="100" />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="footer-action">
      <div class=" button cancel" @click="closeAlert">
        <span>取消</span>
      </div>
      <div class=" button submit" :class="[formDisabled && !resumeToken ? 'disabled' : '']" @click="submitJobDelivery">
        <span>{{deliveryJobOptions.title || '一键投递'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';
import { uuid } from 'vue-uuid'

import api from '@/api';
import conditions from '@/assets/json/conditions'

export default {
  props: {
    deliveryJobOptions: {
      type: Object,
      default: ()=>{
        return {
          jobToken: '',
          title: ''
        }
      }
    },
    isDarkTheme: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      degreesOptions: [],
      jobDeliveryFormData: {
        // cv_token: '', // 简历 token
        university: '', // 学校
        degree: '', // 学历
        dept: '', // 学院
        graduated_at: '', // 毕业时间
        // end_at: '', // 毕业时间
        major: '', // 专业
        name: '', // 姓名
        phone: '', // 手机号
        email: '', // 邮箱
      },
      resumeToken: '',
      rules: {
        university: [
          { required: true, message: '请输入学校', trigger: 'blur' },
        ],
        degree: [
          { required: true, message: '请选择学历', trigger: 'change' },
        ],
        dept: [
          { required: true, message: '请输入学院', trigger: 'blur' },
        ],
        graduated_at: [
          { required: true, message: '请选择毕业时间', trigger: 'change' },
        ],
        major: [
          { required: true, message: '请输入专业', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
      },
      submitLoading: false,
      // deliver_id: uuid.v1(),
      deliver_id: '',
    }
  },
  computed: {
    ...mapState('cv', ['cvs',]),
    // 可投递简历
    eligibleCvs() {
      let eligibleResume = this.cvs.filter(item => item.score >= 80);
      return eligibleResume
    },
    // 整理简历顺序
    formatCvs() {
      let eligibleCvs = this.eligibleCvs;
      let disabledCvs = this.cvs.filter(item => item.score < 80);
      return [...eligibleCvs, ...disabledCvs];
    },
    // 是否禁用提交按钮
    formDisabled() {
      return Object.values(this.jobDeliveryFormData).some(item => !item)
    }
  },
  created() {
    this.degreesOptions = conditions.degrees.filter((item, index) => index>0)
    this.deliver_id = new Date().getTime()
    // 只允许简历80分的投递
    // if(!this.eligibleCvs.length) {
    //   this.$message({
    //     message: '请先完善您的简历信息',
    //     type: 'error',
    //     duration: 3.5 * 1000
    //   });
    //   this.closeAlert()
    // }
  },
  methods: {
    // ...mapMutations('cv', ['']),
    closeAlert() {
      this.$emit('close');
    },
    formValidate () {
      let flag = false
      this.$refs['jobDeliveryForm'].validate(valid => {
        flag = valid
      })
      return flag
    },
    async submitJobDelivery() {
      let formData = {}      
      if (this.resumeToken) {
        formData = {
          cv_token: this.resumeToken
        }
      } else {
        // 检测表单完整性
        let flag = this.formValidate();
        if (!flag) {
          this.$message.error('请完善所有信息')
          return
        }

        let { graduated_at } = this.jobDeliveryFormData;
        formData = {
          ...this.jobDeliveryFormData,
          graduated_at: moment(graduated_at).format('YYYY-MM-DD')
        }
      }

      formData.deliver_id = this.deliver_id;
      
      if(this.submitLoading) return;
      this.submitLoading = true;

      let jobToken = this.deliveryJobOptions?.jobToken || 'aliyun_campus_wonder_cv'
      api.jobs.aliyunDelivery(jobToken, formData).then(res => {
        if(res.code === 1000) {
          this.$message.success('操作成功')
          this.closeAlert();
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            duration: 3.5 * 1000
          });
        }
      }).catch(err => {
        this.$message.error('提交失败')
      }).finally(() => {
        this.submitLoading = false;
      })
      
    }
  }
}
</script>

<style lang="scss" scoped>
.ali-job-delivery-container{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 520px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  padding: 24px 32px;
  box-sizing: border-box;
  .delivery-header{
    margin-bottom: 24px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #1D2129;
      line-height: 22px;
    }
    .desc{
      font-size: 12px;
      color: #86909C;
      margin-top: 8px;
    }
  }

  .footer-action{
    margin-top: 32px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .button{
      padding: 0 16px;
      height: 36px;
      box-sizing: border-box;
      cursor: pointer;
      border-radius: 8px;
    }
    .cancel{
      color: #1D2129;
      border: 1px solid #E5E6EB;
      line-height: 34px;
    }
    .submit{
      color: #fff;
      background-color: #FF6644;
      line-height: 36px;
      &:hover{
        opacity: .8;
      }
      &.disabled{
        background-color: rgba($color: #FF6644, $alpha: 0.6)
        // cursor: not-allowed;
      }
    }
  }

  .form-container{
    
  }

  // 选择简历模式
  .resume-select{
    .el-select{
      width: 100%;
    }
  }
  // 简历表单
  .resume-form{
    .el-form{
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      .form-item{
        flex: 0 1 calc(50% - 8px);
      }
      .edit-module-item-name{
        line-height: 20px;
        margin-bottom: 8px;
      }
      .el-form-item{
        margin-bottom: 0;
      }
      ::v-deep{
        .el-select{
          width: 100%;
        }
      }
    }
  }

  

}
.dark-theme-ali-job-delivery-container{
  background: #25272D;
  .delivery-header{
    .title{
      color: #fff;
    }
    .desc{
      color: #9A9CA2;
    }
  }
  .footer-action{
    .button{
      padding: 0 32px;
      border-radius: 22px;
      height: 44px;
      font-weight: 500;
      span{
        position: relative;
        z-index: 2;
      }
    }
    .cancel{
      background: linear-gradient(90deg, #FFBA52 0%, #F5563C 100%);
      border: 0;
      position: relative;
      line-height: 44px;
      &::before, &:after{
        content: '';
        position: absolute;
        left: 1px;
        right: 1px;
        top: 1px;
        bottom: 1px;
        border-radius: 21px;
        background: #25272D;
        z-index: 1;
      }
      span{
        background: linear-gradient(90deg, #FFB952 1.79%, #F5573D 97.32%);
        -webkit-background-clip: text;
        color: transparent;
      }
      &:hover {
        &::after{
          background: #FF664433;
        }
      }
    }
    .submit{
      background: linear-gradient(90deg, #FFBA52 0%, #F5563C 100%);
      color: #1A1C20;
      line-height: 44px;
      &.disabled{
        opacity: .8;
      }
      &:hover{
        background: linear-gradient(90deg, #FFCC80 0%, #F8816D 100%);
      }
      
    }
  }

  .resume-select{
    ::v-deep{
      .el-select{
        .el-input__inner{
          background: #1A1C20;
          color: #fff;
          border-color: #1A1C20 !important;
        }
        .is-focus{
          .el-input__inner{
            border-color: #fff !important;
          }
        }
      }
    }
  }

  .resume-form{
    .el-form{
      .edit-module-item-name{
        color: #9A9CA2;
      }
      ::v-deep{
        .el-form-item{
          .el-input__inner{
            background: #303336 !important;
            border-color: #303336 !important;
            color: #fff;
          }
          &.is-error{
            .el-input__inner{
              border-color: #F56C6C !important;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ali-job-delivery-select-resume-option{
  display: flex;
  align-items: center;
  gap: 8px;
  .name{
    flex: 1;
    max-width: 330px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1D2129;
  }
  .score{
    padding: 0 8px;
    line-height: 22px;
    border-radius: 4px;
    font-weight: 500;
    background: #FFECE8;
    color: #CB272D;
  }
  .lang{
    padding: 0 8px;
    line-height: 22px;
    border-radius: 4px;
    font-weight: 500;
    background: #E8F2FF;
    color: #1033A3;
  }
  &.disabled{
    .name{
      color: #A9AEB8;
    }
    .score, .lang{
      color: #86909C;
      background: #EFF0F1;
    }
  }
}
.dark-theme-ali-job-delivery-select{
  border-color: #303336 !important;
  background: #303336 !important;
  .popper__arrow{
    border-bottom-color: #303336 !important;
    &::after{
      border-bottom-color: #303336 !important;
    }
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #25272D;
    border-radius: 4px;
  }
  .el-select-dropdown__item.is-disabled:hover{
    background-color: #303336 !important;
  }
  .ali-job-delivery-select-resume-option{
    .name{
      color: #fff;
    }
    .score{
      background: #D6C7C4;
      color: #CB272D;
    }
    .lang{
      background: #C3CCD7;
      color: #1033A3;
    }
    &.disabled{
      .name{
        color: #808080;
      }
      .score, .lang{
        color: #A9AEB8;
        background: #484D51;
      }
    }
  }
}
</style>